module.exports = __webpack_public_path__ + "media/images/logo-alternate-5969b329f047f4e5f6a8144ee03b446f.svg";